import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { ButtonBox } from '@/components/UI/Button/Button.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: relative;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const Title = styled(Typography.Header)`
  font-size: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: absolute;
    left: 50%;
    font-size: 16px;
    font-weight: 500;
    transform: translateX(-50%);
  }
`;

export const CancelButton = styled(Button).attrs({
  appearance: 'transparent',
  hasPadding: false,
})`
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.system.blue};

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.palette.system.deepBlue};
    }
  }
`;

export const Banner = styled(Typography.Body).attrs({ $variant: '1' })`
  width: 100%;
  padding: 15px;
  border-radius: 14px;
  font-size: 13px;
  line-height: 20px;
  white-space: pre-line;
  background-color: ${({ theme }) => theme.palette.system.lightYellow};
  color: ${({ theme }) => theme.palette.primary.labels};

  span {
    display: block;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 12px;
  }
`;

export const SelectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 20px;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
`;

export const ContinueButtonBox = styled.div`
  width: 280px;
  border-radius: 14px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const ServicePickerDescription = styled(Typography.Body).attrs({
  $variant: '1',
})`
  font-size: 16px;
  margin-bottom: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
  }
`;

export const ServiceArrow = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  svg {
    width: 17px;
    height: 10px;
    transform: rotate(-90deg);
  }
`;

export const SuccessModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  width: 100%;
  padding: 40px 50px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 25px 20px 20px;
    gap: 20px;
  }
`;

export const SuccessLogo = styled(IconBox).attrs({
  $filename: 'Tap.svg',
  $width: 60,
  $height: 18,
  $iconWidth: 60,
  $iconHeight: 18,
})``;

export const SuccessTitle = styled(Typography.Header).attrs({
  $variant: '3',
})`
  font-size: 18px;
  color: ${({ theme }) => theme.palette.system.green};
  text-align: center;
`;

export const SuccessAmount = styled(Typography.Header).attrs({
  $variant: '2',
})`
  font-size: 24px;
`;

export const SuccessDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  padding: 25px 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const SuccessDetailRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr);
  align-items: center;
  gap: 10px;
`;

export const SuccessDetailLabel = styled(Typography.Body).attrs({
  $variant: '1',
})`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const SuccessDetailValue = styled(Typography.Body).attrs({
  $variant: '1',
})`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: right;
`;

export const SuccessActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const SuccessHistoryLink = styled(ButtonBox).attrs({
  $appearance: 'secondaryLight',
  $isFullWidth: true,
  $hasPadding: true,
  $size: 'm',
  $borderRadius: 14,
})`
  text-decoration: none;
`;
